import React from 'react';
import ChecklistOptionHeader from 'components/common/headers/ChecklistOptionHeader';
import { CARD_DATA } from 'global/checklists-helpers/ChecklistHelper';

const RenewalFormsHeader = (): JSX.Element => {
  return (
    <ChecklistOptionHeader
      tutorialLink={CARD_DATA.RENEWAL_FORMS.tutorialLink}
      title={CARD_DATA.RENEWAL_FORMS.title}
      subtitle={CARD_DATA.RENEWAL_FORMS.text}
    />
  );
};

export default RenewalFormsHeader;
